/** 画面名定数 */
export const MEMBER_REGISTER_FILE_NAME = "MemberRegister";
